/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconDeviceWatchStats2 = createReactComponent("outline", "device-watch-stats-2", "IconDeviceWatchStats2", [["path", { "d": "M6 6m0 3a3 3 0 0 1 3 -3h6a3 3 0 0 1 3 3v6a3 3 0 0 1 -3 3h-6a3 3 0 0 1 -3 -3z", "key": "svg-0" }], ["path", { "d": "M9 18v3h6v-3", "key": "svg-1" }], ["path", { "d": "M9 6v-3h6v3", "key": "svg-2" }], ["path", { "d": "M12 10a2 2 0 1 0 2 2", "key": "svg-3" }]]);

export { IconDeviceWatchStats2 as default };
//# sourceMappingURL=IconDeviceWatchStats2.mjs.map
